module.exports = __webpack_public_path__ + "img/2020-07-17.9263ffa9.jpg";